import React, { useEffect, useState } from "react";
import { QRCode } from "react-qrcode-logo";
import printJS from "print-js";
import axios from "axios";
import { getQrImgaeUrl } from "../../assets/api/BaseURL";

const QRCodeGenerator = ({ link, qrId }) => {
  const [logo, setLogo] = useState(null);

  const fetchLogoImage = async () => {
    try {
      const response = await axios.post(getQrImgaeUrl, {}, {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        responseType: "blob", // ✅ because backend sends image buffer
      });

      // Convert blob to base64 data URL
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogo(reader.result); // base64 image
      };
      reader.readAsDataURL(response.data);

    } catch (error) {
      console.error("Error fetching logo image:", error);
    }
  };

  useEffect(() => {
    fetchLogoImage();
  }, []);

  const downloadCode = () => {
    const canvas = document.getElementById(`qr-${qrId}`);
    if (canvas) {
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = `qrcode-${qrId}.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  const printCode = () => {
    printJS({
      printable: qrId,
      type: "html",
      targetStyles: ["*"],
    });
  };

  return (
    <div className="d-sm-flex justify-content-start align-items-center">
      <div>
        <QRCode
          value={link}
          ecLevel="H"
          logoImage={logo}
          logoOpacity={1}
          enableCORS={true}
          logoWidth={40}
          logoHeight={40}
          removeQrCodeBehindLogo={true}
          id={qrId}
        />
      </div>

      <div style={{ display: "none" }}>
        <QRCode
          value={link}
          ecLevel="H"
          logoImage={logo}
          logoOpacity={1}
          enableCORS={true}
          size={980}
          removeQrCodeBehindLogo={true}
          id={`qr-${qrId}`}
        />
      </div>

      <div>
        <button className="btn btn-primary btn-sm" onClick={downloadCode}>
          <span className="mdi mdi-download"></span>
        </button>
        &nbsp;&nbsp;
        <button className="btn btn-primary btn-sm" onClick={printCode}>
          <span className="mdi mdi-printer"></span>
        </button>
      </div>
    </div>
  );
};

export default QRCodeGenerator;
